// Portal de cuenta Aprendiendo (dentro del tema Shopify).
// Login OTP + Mis compras + Mi perfil + Admin. Usa Supabase JS (navegador) y
// Edge Functions para lo que toca secretos.
import { createClient } from "https://esm.sh/@supabase/supabase-js@2";

const root = document.getElementById("pm-account");
const SUPABASE_URL = root.dataset.supabaseUrl;
const ANON_KEY = root.dataset.anonKey;
const supabase = createClient(SUPABASE_URL, ANON_KEY);

const LOGO = root.dataset.logo;
const EMAIL_RE = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;

const ICON = {
  bag: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>',
  user: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>',
  shield: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1Z"/></svg>',
  logout: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><path d="m16 17 5-5-5-5"/><path d="M21 12H9"/></svg>',
  download: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" x2="12" y1="15" y2="3"/></svg>',
  menu: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="4" x2="20" y1="6" y2="6"/><line x1="4" x2="20" y1="12" y2="12"/><line x1="4" x2="20" y1="18" y2="18"/></svg>',
  book: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2Z"/></svg>',
  receipt: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z"/><path d="M8 7h8"/><path d="M8 11h8"/><path d="M8 15h5"/></svg>',
  settings: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/></svg>',
  chart: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 3v18h18"/><path d="m19 9-5 5-4-4-3 3"/></svg>',
};

let state = { user: null, profile: null, view: "compras" };
let adminData = null;
let ordersData = null;
let purchasesData = null;
let trackingData = {};

function esc(s) {
  return String(s ?? "").replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
}
function initials(p) {
  const f = (p?.first_name || "").trim()[0] || "";
  const l = (p?.last_name || "").trim()[0] || "";
  return ((f + l) || (state.user?.email?.[0] || "A")).toUpperCase();
}
function fullName(p) {
  const n = [p?.first_name, p?.last_name].filter(Boolean).join(" ").trim();
  return n || "Tu cuenta";
}

/* ============ LOGIN ============ */
function renderLogin() {
  root.innerHTML = `
    <div class="apr-login-wrap">
      <div class="apr-login-bar apr-gradient"></div>
      <div class="apr-card" style="margin-top:24px">
        <img class="apr-logo" src="${esc(LOGO)}" alt="Aprendiendo" />
        <div id="apr-step"></div>
      </div>
      <p class="apr-note">Crea tu cuenta o accede con tu correo. Te enviamos un código de un solo uso, sin contraseñas.</p>
    </div>`;
  renderEmailStep();
}

function renderEmailStep(prefill = "") {
  document.getElementById("apr-step").innerHTML = `
    <h1 class="apr-title">Crea tu cuenta o accede</h1>
    <p class="apr-sub">Escribe tu correo y te enviamos un código para entrar. Si es tu primera vez, tu cuenta se crea sola.</p>
    <div class="apr-field">
      <label class="apr-label" for="apr-email">Correo</label>
      <input class="apr-input" id="apr-email" type="email" inputmode="email" autocomplete="email" placeholder="tu@email.com" value="${esc(prefill)}" />
    </div>
    <p class="apr-error apr-hidden" id="apr-email-err"></p>
    <button class="apr-btn apr-btn-primary" id="apr-send">Envíame el código</button>`;
  const input = document.getElementById("apr-email");
  const btn = document.getElementById("apr-send");
  input.focus();
  const submit = async () => {
    const email = input.value.trim().toLowerCase();
    const err = document.getElementById("apr-email-err");
    if (!EMAIL_RE.test(email)) { err.textContent = "Escribe un correo válido."; err.classList.remove("apr-hidden"); return; }
    err.classList.add("apr-hidden");
    btn.disabled = true; btn.innerHTML = '<span class="apr-spin"></span>';
    try { await supabase.functions.invoke("request-login-code", { body: { email } }); }
    catch (e) { console.error(e); }
    renderCodeStep(email);
  };
  btn.addEventListener("click", submit);
  input.addEventListener("keydown", (e) => { if (e.key === "Enter") submit(); });
}

function renderCodeStep(email) {
  const N = 8; // el código que genera Supabase es de 8 dígitos
  const boxes = Array.from({ length: N }, (_, i) =>
    `<input class="apr-otp-box" type="text" inputmode="numeric" pattern="[0-9]*" maxlength="1" aria-label="Dígito ${i + 1}"${i === 0 ? ' autocomplete="one-time-code"' : ' autocomplete="off"'} />`
  ).join("");
  document.getElementById("apr-step").innerHTML = `
    <h1 class="apr-title">Revisa tu correo</h1>
    <p class="apr-sub">Te enviamos un código a <strong>${esc(email)}</strong>. Escríbelo o pégalo aquí.</p>
    <div class="apr-field">
      <label class="apr-label">Código</label>
      <div class="apr-otp-group" id="apr-otp" role="group" aria-label="Código de acceso">${boxes}</div>
    </div>
    <p class="apr-error apr-hidden" id="apr-code-err"></p>
    <button class="apr-btn apr-btn-primary" id="apr-verify">Entrar</button>
    <button class="apr-link" id="apr-back">Usar otro correo</button>`;
  const boxEls = Array.from(document.getElementById("apr-otp").querySelectorAll(".apr-otp-box"));
  const btn = document.getElementById("apr-verify");
  const err = document.getElementById("apr-code-err");

  const getCode = () => boxEls.map((b) => b.value).join("");
  const setBoxes = (str) => {
    const digits = String(str).replace(/\D/g, "").slice(0, N).split("");
    boxEls.forEach((b, i) => { b.value = digits[i] || ""; b.classList.toggle("is-filled", Boolean(digits[i])); });
    boxEls[Math.min(digits.length, N - 1)].focus();
  };
  const clearBoxes = () => { boxEls.forEach((b) => { b.value = ""; b.classList.remove("is-filled"); }); boxEls[0].focus(); };

  const submit = async () => {
    const code = getCode().trim();
    if (!/^\d{6,10}$/.test(code)) { err.textContent = "Ingresa el código que te enviamos al correo."; err.classList.remove("apr-hidden"); return; }
    err.classList.add("apr-hidden");
    btn.disabled = true; btn.innerHTML = '<span class="apr-spin"></span>';
    // Acepta el código venga del correo "Magic link or OTP" (type email) o del
    // de "Confirm sign up" (type signup), para no depender de un solo flujo.
    let result = await supabase.auth.verifyOtp({ email, token: code, type: "email" });
    if (result.error) result = await supabase.auth.verifyOtp({ email, token: code, type: "magiclink" });
    if (result.error) result = await supabase.auth.verifyOtp({ email, token: code, type: "signup" });
    if (result.error) {
      err.textContent = "El código no es válido o ya venció. Pide uno nuevo.";
      err.classList.remove("apr-hidden");
      btn.disabled = false; btn.textContent = "Entrar";
      clearBoxes();
      return;
    }
    await loadAppData();
  };

  boxEls.forEach((box, i) => {
    box.addEventListener("input", () => {
      err.classList.add("apr-hidden");
      const raw = box.value.replace(/\D/g, "");
      if (raw.length > 1) { setBoxes(raw); return; } // pegado/autocompletado en una sola casilla
      box.value = raw;
      box.classList.toggle("is-filled", Boolean(raw));
      if (raw && i < N - 1) boxEls[i + 1].focus();
    });
    box.addEventListener("keydown", (e) => {
      if (e.key === "Backspace") {
        if (box.value) { box.value = ""; box.classList.remove("is-filled"); }
        else if (i > 0) { boxEls[i - 1].focus(); boxEls[i - 1].value = ""; boxEls[i - 1].classList.remove("is-filled"); }
      } else if (e.key === "ArrowLeft" && i > 0) { e.preventDefault(); boxEls[i - 1].focus(); }
      else if (e.key === "ArrowRight" && i < N - 1) { e.preventDefault(); boxEls[i + 1].focus(); }
      else if (e.key === "Enter") { e.preventDefault(); submit(); }
    });
    box.addEventListener("paste", (e) => {
      e.preventDefault();
      const text = (e.clipboardData || window.clipboardData).getData("text");
      setBoxes(text);
    });
    box.addEventListener("focus", () => box.select());
  });
  boxEls[0].focus();

  btn.addEventListener("click", submit);
  document.getElementById("apr-back").addEventListener("click", () => renderEmailStep(email));
}

/* ============ APP ============ */
async function loadAppData() {
  const { data: { user } } = await supabase.auth.getUser();
  if (!user) { renderLogin(); return; }
  state.user = user;
  const { data: profile } = await supabase
    .from("profiles")
    .select("email, first_name, last_name, avatar_url, role")
    .eq("id", user.id)
    .maybeSingle();
  state.profile = profile || { email: user.email, role: "customer" };
  // Restaura la pestaña donde estaba el usuario (sobrevive a recargar la página).
  try {
    const nav = JSON.parse(localStorage.getItem("apr_nav") || "null");
    if (nav && nav.view) {
      state.view = (nav.view === "admin" && state.profile.role !== "admin") ? "compras" : nav.view;
      if (nav.adminTab) state.adminTab = nav.adminTab;
      if (nav.adminFunnel) state.adminFunnel = nav.adminFunnel;
      if (nav.funnelTab) state.funnelTab = nav.funnelTab;
    }
  } catch (e) {}
  renderApp();
}

function saveNav() {
  try { localStorage.setItem("apr_nav", JSON.stringify({ view: state.view, adminTab: state.adminTab || null, adminFunnel: state.adminFunnel || null, funnelTab: state.funnelTab || null })); } catch (e) {}
}

function navItems() {
  const items = [];
  if (state.profile?.role === "admin") {
    items.push({ id: "admin", label: "Admin", icon: ICON.shield });
  }
  items.push({ id: "perfil", label: "Mi perfil", icon: ICON.user });
  items.push({ id: "compras", label: "Mis compras", icon: ICON.bag });
  return items;
}

function sidebarHtml() {
  const p = state.profile;
  const avatar = p?.avatar_url
    ? `<span class="apr-avatar"><img class="apr-avatar-inner" src="${esc(p.avatar_url)}" alt="" /></span>`
    : `<span class="apr-avatar">${esc(initials(p))}</span>`;
  const nav = navItems().map((i) =>
    `<button data-view="${i.id}" class="${state.view === i.id ? "is-active" : ""}">${i.icon}<span>${i.label}</span></button>`
  ).join("");
  return `
    <img class="apr-logo" src="${esc(LOGO)}" alt="Aprendiendo" />
    <nav class="apr-nav">${nav}</nav>
    <div class="apr-usercard">
      ${avatar}
      <div style="min-width:0;flex:1">
        <p class="apr-uname">${esc(fullName(p))}</p>
        <p class="apr-umail">${esc(p?.email || state.user.email)}</p>
      </div>
    </div>
    <button class="apr-logout-btn" id="apr-logout">${ICON.logout}<span>Cerrar sesión</span></button>`;
}

function renderApp() {
  root.innerHTML = `
    <div class="apr-app">
      <aside class="apr-side" id="apr-side">${sidebarHtml()}</aside>
      <div class="apr-main">
        <div class="apr-topbar">
          <img class="apr-logo" style="height:28px;margin:0" src="${esc(LOGO)}" alt="Aprendiendo" />
          <button class="apr-link" style="width:auto;margin:0" id="apr-menu" aria-label="Menú">${ICON.menu}</button>
        </div>
        <div class="apr-content" id="apr-content"></div>
      </div>
    </div>`;
  bindAppEvents();
  renderView();
}

function bindAppEvents() {
  root.querySelectorAll("[data-view]").forEach((b) =>
    b.addEventListener("click", () => {
      state.view = b.dataset.view;
      const side = document.getElementById("apr-side");
      if (side) side.classList.remove("is-open");
      refreshActive();
      renderView();
    })
  );
  const logout = document.getElementById("apr-logout");
  if (logout) logout.addEventListener("click", async () => { await supabase.auth.signOut(); state = { user: null, profile: null, view: "compras" }; adminData = null; ordersData = null; purchasesData = null; trackingData = {}; try { localStorage.removeItem("apr_nav"); } catch (e) {} renderLogin(); });
  const menu = document.getElementById("apr-menu");
  if (menu) menu.addEventListener("click", () => document.getElementById("apr-side")?.classList.toggle("is-open"));
}

function refreshActive() {
  root.querySelectorAll("[data-view]").forEach((b) => b.classList.toggle("is-active", b.dataset.view === state.view));
}

function renderView() {
  const c = document.getElementById("apr-content");
  saveNav();
  if (state.view === "perfil") return renderPerfil(c);
  if (state.view === "admin") return renderAdminArea(c);
  return renderCompras(c);
}

/* ---- Mis compras ---- */
async function renderCompras(c) {
  const head = `<h1 class="apr-h1">Mis compras</h1><p class="apr-pagesub">Tus productos listos para descargar.</p>`;
  if (!purchasesData) {
    c.innerHTML = head + `<div class="apr-center"><span class="apr-spin"></span></div>`;
    const { data, error } = await supabase.functions.invoke("my-purchases", { method: "GET" });
    if (error || !data || !data.ok) { c.innerHTML = head + `<div class="apr-empty">No pudimos cargar tus compras.</div>`; return; }
    purchasesData = data.items || [];
  }
  const items = purchasesData;
  if (items.length === 0) {
    // Detecta la última tienda/funnel que visitó (guardada por el header) para
    // invitarlo a volver a comprar. Si no hay, lleva al inicio de la marca.
    let back = null;
    try { back = JSON.parse(localStorage.getItem("apr_store_back") || "null"); } catch (e) {}
    const backUrl = (back && (back.home || back.catalog)) || "/";
    c.innerHTML = head + `<div class="apr-empty">${ICON.bag}<h2>Aún no tienes compras</h2><p>Cuando compres un producto aparecerá aquí para que lo descargues al instante.</p><a class="apr-btn apr-btn-primary apr-btn-inline" href="${esc(backUrl)}" style="margin-top:20px">Explorar la tienda →</a></div>`;
    return;
  }
  const cards = items.map((it) => {
    const date = it.purchasedAt ? new Date(it.purchasedAt).toLocaleDateString("es", { day: "numeric", month: "long", year: "numeric" }) : "";
    const cover = it.image
      ? `<div class="apr-prod-cover"><img src="${esc(it.image)}" alt="${esc(it.title || "")}" /></div>`
      : `<div class="apr-prod-cover apr-gradient" style="color:#fff">${ICON.book}</div>`;
    return `<div class="apr-prod">
      ${cover}
      <div class="apr-prod-body">
        <h3 class="apr-prod-title">${esc(it.title || "Tu producto")}</h3>
        ${date ? `<p class="apr-prod-date">Comprado el ${esc(date)}</p>` : ""}
        <button class="apr-btn apr-btn-primary apr-prod-dl" data-dl="${esc(it.id)}">${ICON.download}<span>Descargar</span></button>
        <p class="apr-help apr-hidden" data-dlmsg="${esc(it.id)}" style="text-align:center"></p>
      </div></div>`;
  }).join("");
  c.innerHTML = head + `<div class="apr-grid">${cards}</div>`;
  c.querySelectorAll("[data-dl]").forEach((btn) => btn.addEventListener("click", () => onDownload(btn.dataset.dl, btn)));
}

async function onDownload(entitlementId, btn) {
  const msg = btn.parentElement.querySelector("[data-dlmsg]");
  msg.classList.add("apr-hidden");
  const original = btn.innerHTML;
  btn.disabled = true; btn.innerHTML = '<span class="apr-spin"></span>';
  try {
    const { data, error } = await supabase.functions.invoke("get-download-url", { body: { entitlementId } });
    if (data && data.ok) {
      window.open(data.url, "_blank", "noopener,noreferrer");
    } else if (data && data.reason === "not_ready") {
      msg.textContent = "La descarga estará lista muy pronto."; msg.classList.remove("apr-hidden");
    } else if (error) {
      msg.textContent = "No tienes acceso a este producto."; msg.classList.remove("apr-hidden");
    } else {
      msg.textContent = "No pudimos abrir la descarga."; msg.classList.remove("apr-hidden");
    }
  } catch (e) {
    msg.textContent = "No pudimos abrir la descarga."; msg.classList.remove("apr-hidden");
  } finally {
    btn.disabled = false; btn.innerHTML = original;
  }
}

/* ---- Mi perfil ---- */
function renderPerfil(c) {
  const p = state.profile;
  const avatar = p?.avatar_url
    ? `<span class="apr-avatar-lg" id="apr-av"><img class="apr-avatar-inner" src="${esc(p.avatar_url)}" alt="" /></span>`
    : `<span class="apr-avatar-lg" id="apr-av">${esc(initials(p))}</span>`;
  c.innerHTML = `
    <h1 class="apr-h1">Mi perfil</h1>
    <p class="apr-pagesub">Personaliza tu cuenta. Tu correo no se puede cambiar.</p>
    <div class="apr-form">
      <div class="apr-avatar-row">
        ${avatar}
        <div>
          <button class="apr-btn apr-btn-primary apr-btn-inline" id="apr-avbtn" style="height:40px">Cambiar foto</button>
          <p class="apr-help">PNG, JPG o WebP · máx. 2 MB</p>
          <input type="file" id="apr-avfile" accept="image/png,image/jpeg,image/webp" class="apr-hidden" />
        </div>
      </div>
      <div class="apr-row2">
        <div><label class="apr-label" for="apr-fn">Nombre</label><input class="apr-input" id="apr-fn" maxlength="60" value="${esc(p?.first_name || "")}" placeholder="Tu nombre" /></div>
        <div><label class="apr-label" for="apr-ln">Apellido</label><input class="apr-input" id="apr-ln" maxlength="60" value="${esc(p?.last_name || "")}" placeholder="Tu apellido" /></div>
      </div>
      <div style="margin-top:16px">
        <label class="apr-label" for="apr-em">Correo</label>
        <input class="apr-input apr-readonly" id="apr-em" value="${esc(p?.email || state.user.email)}" readonly />
        <p class="apr-help">Es el correo con el que compraste, por eso no se puede cambiar.</p>
      </div>
      <p class="apr-error apr-hidden" id="apr-perr"></p>
      <div style="margin-top:22px;display:flex;align-items:center;gap:14px">
        <button class="apr-btn apr-btn-primary apr-btn-inline" id="apr-save">Guardar cambios</button>
        <span id="apr-saved" class="apr-hidden" style="color:var(--apr-aqua);font-weight:600;font-size:14px">✓ Guardado</span>
      </div>
    </div>`;
  document.getElementById("apr-avbtn").addEventListener("click", () => document.getElementById("apr-avfile").click());
  document.getElementById("apr-avfile").addEventListener("change", onAvatar);
  document.getElementById("apr-save").addEventListener("click", onSaveProfile);
}

async function onSaveProfile() {
  const btn = document.getElementById("apr-save");
  const err = document.getElementById("apr-perr");
  const saved = document.getElementById("apr-saved");
  err.classList.add("apr-hidden"); saved.classList.add("apr-hidden");
  const first_name = document.getElementById("apr-fn").value.trim();
  const last_name = document.getElementById("apr-ln").value.trim();
  btn.disabled = true; btn.innerHTML = '<span class="apr-spin"></span>';
  const { error } = await supabase.from("profiles").update({ first_name: first_name || null, last_name: last_name || null }).eq("id", state.user.id);
  btn.disabled = false; btn.textContent = "Guardar cambios";
  if (error) { err.textContent = "No pudimos guardar los cambios."; err.classList.remove("apr-hidden"); return; }
  state.profile.first_name = first_name; state.profile.last_name = last_name;
  saved.classList.remove("apr-hidden");
  const side = document.getElementById("apr-side"); if (side) side.innerHTML = sidebarHtml(), bindAppEvents();
}

function onAvatar(e) {
  const file = e.target.files?.[0];
  e.target.value = "";
  if (!file) return;
  const err = document.getElementById("apr-perr");
  err.classList.add("apr-hidden");
  if (!["image/png", "image/jpeg", "image/webp"].includes(file.type)) { err.textContent = "Usa una imagen PNG, JPG o WebP."; err.classList.remove("apr-hidden"); return; }
  if (file.size > 2_000_000) { err.textContent = "La imagen debe pesar menos de 2 MB."; err.classList.remove("apr-hidden"); return; }
  const btn = document.getElementById("apr-avbtn");
  if (btn) { btn.disabled = true; btn.textContent = "Subiendo…"; }
  const resetBtn = () => { const b = document.getElementById("apr-avbtn"); if (b) { b.disabled = false; b.textContent = "Cambiar foto"; } };
  const reader = new FileReader();
  reader.onload = async () => {
    try {
      const base64 = String(reader.result).split(",")[1] || "";
      const { data, error } = await supabase.functions.invoke("upload-avatar", { body: { fileBase64: base64, contentType: file.type } });
      if (error || !data || !data.ok) {
        err.textContent = "No pudimos subir la foto: " + ((data && data.error) || "intenta de nuevo");
        err.classList.remove("apr-hidden");
        resetBtn();
        return;
      }
      state.profile.avatar_url = data.url;
      renderPerfil(document.getElementById("apr-content"));
      const side = document.getElementById("apr-side"); if (side) { side.innerHTML = sidebarHtml(); bindAppEvents(); }
    } catch (e2) {
      err.textContent = "No pudimos subir la foto."; err.classList.remove("apr-hidden"); resetBtn();
    }
  };
  reader.onerror = () => { err.textContent = "No pudimos leer la imagen."; err.classList.remove("apr-hidden"); resetBtn(); };
  reader.readAsDataURL(file);
}

/* ---- Admin (solo administrador): contenedor con sub-pestañas ---- */
function renderAdminArea(c) {
  if (!state.adminTab) state.adminTab = "productos";
  const tabs = [
    { id: "productos", label: "Funnels", icon: ICON.shield },
    { id: "pedidos", label: "Pedidos", icon: ICON.receipt },
  ];
  c.innerHTML = `
    <h1 class="apr-h1">Admin</h1>
    <p class="apr-pagesub">Panel de administración de tu tienda.</p>
    <div class="apr-subtabs">${tabs.map((t) => `<button class="apr-subtab ${state.adminTab === t.id ? "is-active" : ""}" data-atab="${t.id}">${t.icon}<span>${t.label}</span></button>`).join("")}</div>
    <div id="apr-admin-content"></div>`;
  c.querySelectorAll("[data-atab]").forEach((b) => b.addEventListener("click", () => {
    state.adminTab = b.dataset.atab;
    c.querySelectorAll("[data-atab]").forEach((x) => x.classList.toggle("is-active", x.dataset.atab === state.adminTab));
    renderAdminTab();
  }));
  renderAdminTab();
}

function renderAdminTab() {
  const ac = document.getElementById("apr-admin-content");
  if (!ac) return;
  saveNav();
  if (state.adminTab === "pedidos") return renderPedidos(ac);
  return renderAdmin(ac);
}

/* ---- Admin · Funnels (tarjetas cuadradas → detalle del funnel) ---- */
async function renderAdmin(c) {
  const head = `<p class="apr-pagesub" style="margin:18px 0 8px">Tus funnels. Entra a uno para poner el enlace de descarga de su producto principal y sus order bumps.</p>`;
  if (!adminData) {
    c.innerHTML = head + `<div class="apr-center"><span class="apr-spin"></span></div>`;
    const [prodRes, trkRes] = await Promise.all([
      supabase.functions.invoke("admin-products", { method: "GET" }),
      supabase.functions.invoke("admin-tracking", { method: "GET" }),
    ]);
    const { data, error } = prodRes;
    if (error || !data || !data.ok) { c.innerHTML = head + `<div class="apr-empty">No pudimos cargar el panel.</div>`; return; }
    if (!data.configured) { c.innerHTML = head + `<div class="apr-empty"><h2>Conecta Shopify</h2><p>Falta conectar el acceso a la tienda. En cuanto esté, verás aquí tus funnels.</p></div>`; return; }
    if (!data.groups.length) { c.innerHTML = head + `<div class="apr-empty">No encontramos productos en la tienda.</div>`; return; }
    adminData = data;
    trackingData = (trkRes && trkRes.data && trkRes.data.ok && trkRes.data.configs) ? trkRes.data.configs : {};
  }
  c.innerHTML = head + `
    <div class="apr-toolbar">
      <input class="apr-input apr-search" id="apr-prod-q" type="search" placeholder="Buscar producto en todos los funnels…" />
    </div>
    <div id="apr-prod-list"></div>`;
  document.getElementById("apr-prod-q").addEventListener("input", renderAdminList);
  renderAdminList();
}

function funnelMainImage(g) {
  const main = g.products.find((p) => p.role === "principal") || g.products[0];
  return main && main.imageUrl ? main.imageUrl : null;
}

function funnelCardHtml(g) {
  const img = funnelMainImage(g);
  const cover = img
    ? `<div class="apr-prod-cover"><img src="${esc(img)}" alt="" /></div>`
    : `<div class="apr-prod-cover apr-gradient" style="color:#fff">${ICON.shield}</div>`;
  return `<button class="apr-prod apr-funnel-card" data-funnel="${esc(g.funnelHandle)}">
    ${cover}
    <div class="apr-prod-body">
      <h3 class="apr-prod-title">${esc(g.funnel)}</h3>
      <p class="apr-prod-date">${g.products.length} producto${g.products.length === 1 ? "" : "s"}</p>
    </div></button>`;
}

function adminRowHtml(p, funnelLabel, displayRole) {
  const has = p.downloadUrl && p.downloadUrl.length > 0;
  const thumb = p.imageUrl ? `<img class="apr-athumb" src="${esc(p.imageUrl)}" alt="" />` : `<span class="apr-athumb"></span>`;
  const role = displayRole !== undefined ? displayRole : p.role;
  const roleBadge = role === "principal" ? `<span class="apr-chip apr-chip-main">★ Principal</span>`
    : role === "bump" ? `<span class="apr-chip apr-chip-bump">Order bump</span>` : "";
  const funnelChip = funnelLabel ? `<span class="apr-chip apr-chip-bump">${esc(funnelLabel)}</span>` : "";
  const cls = p.role === "bump" ? "apr-arow apr-arow-bump" : "apr-arow";
  return `<div class="${cls}">
    ${thumb}
    <div class="apr-abody">
      <div style="display:flex;align-items:center;gap:8px;flex-wrap:wrap">
        <strong style="font-size:14px">${esc(p.title)}</strong>
        ${roleBadge}${funnelChip}
        <span class="apr-chip apr-dlchip ${has ? "apr-chip-ok" : "apr-chip-warn"}">${has ? "Con descarga" : "Falta enlace"}</span>
      </div>
      ${p.storeUrl ? `<a class="apr-slug" href="${esc(p.storeUrl)}" target="_blank" rel="noopener">/${esc(p.handle)} ↗</a>` : `<span class="apr-slug">/${esc(p.handle)}</span>`}
      <div class="apr-aurl">
        <input class="apr-input" placeholder="https://…  enlace de descarga" value="${esc(p.downloadUrl || "")}" data-url="${esc(p.shopifyProductId)}" />
        <button class="apr-btn apr-btn-primary" data-save="${esc(p.shopifyProductId)}" data-title="${esc(p.title)}" data-handle="${esc(p.handle)}">Guardar</button>
      </div>
      <p class="apr-help apr-hidden" data-amsg="${esc(p.shopifyProductId)}"></p>
    </div></div>`;
}

function bindSaves(scope) {
  scope.querySelectorAll("[data-save]").forEach((btn) => btn.addEventListener("click", () => onSaveProduct(btn)));
}

function renderAdminList() {
  const list = document.getElementById("apr-prod-list");
  if (!list || !adminData) return;
  saveNav();
  const q = (document.getElementById("apr-prod-q")?.value || "").trim().toLowerCase();

  // 1) Búsqueda global (resultados planos, con su funnel)
  if (q) {
    const matches = [];
    for (const g of adminData.groups) {
      for (const p of g.products) {
        if ((p.title || "").toLowerCase().includes(q) || (p.handle || "").toLowerCase().includes(q)) matches.push(adminRowHtml(p, g.funnel));
      }
    }
    list.innerHTML = matches.length ? matches.join("") : `<div class="apr-empty">No hay productos que coincidan.</div>`;
    bindSaves(list);
    return;
  }

  // 2) Detalle de un funnel (principal + order bumps)
  if (state.adminFunnel) {
    const g = adminData.groups.find((x) => x.funnelHandle === state.adminFunnel);
    if (!g) { state.adminFunnel = null; renderAdminList(); return; }
    if (!state.funnelTab) state.funnelTab = "config";
    const ft = state.funnelTab;
    const ftabs = [
      { id: "config", icon: ICON.settings, label: "Configuración" },
      { id: "tracking", icon: ICON.chart, label: "Seguimiento" },
      { id: "pages", icon: ICON.book, label: "Páginas" },
      { id: "downloads", icon: ICON.download, label: "Descargas" },
    ];
    let body = "";
    if (ft === "config") {
      body = checkoutCardHtml(g);
    } else if (ft === "tracking") {
      body = trackingCardHtml(g);
    } else if (ft === "pages") {
      body = pagesCardHtml(g);
    } else {
      const principal = g.products.filter((p) => p.role === "principal");
      const bumps = g.products.filter((p) => p.role === "bump");
      const store = g.products.filter((p) => p.role !== "principal" && p.role !== "bump");
      const mode = (trackingData[g.funnelHandle] && trackingData[g.funnelHandle].checkoutMode) || "page";
      const section = (title, arr, dispRole) => arr.length ? `<p class="apr-dl-h">${title}</p>` + arr.map((p) => adminRowHtml(p, undefined, dispRole)).join("") : "";
      const intro = `<p class="apr-help" style="margin:16px 0 4px">Pega el enlace de descarga de cada producto. El cliente lo recibe al comprar.</p>`;
      if (mode === "popup") {
        // Funnel tipo Single: producto principal → productos de tienda → order bumps
        body = intro
          + section("⭐ Producto principal", principal)
          + section("🛍️ Productos de tienda", store)
          + section("🎁 Order bumps", bumps);
      } else {
        // Funnel tipo Tienda: no hay producto principal (el Kit es un producto más) → productos arriba, order bumps abajo
        body = intro
          + section("🛍️ Productos", principal.concat(store), "")
          + section("🎁 Order bumps", bumps);
      }
    }
    list.innerHTML = `
      <button class="apr-back" id="apr-funnel-back">← Volver a funnels</button>
      <div class="apr-funnel-head"><h2>${esc(g.funnel)}</h2><span class="apr-help">${g.products.length} producto${g.products.length === 1 ? "" : "s"}</span></div>
      <div class="apr-subtabs">${ftabs.map((t) => `<button class="apr-subtab ${ft === t.id ? "is-active" : ""}" data-ftab="${t.id}">${t.icon}<span>${t.label}</span></button>`).join("")}</div>
      <div id="apr-ftab-body">${body}</div>`;
    document.getElementById("apr-funnel-back").addEventListener("click", () => { state.adminFunnel = null; state.funnelTab = "config"; renderAdminList(); });
    list.querySelectorAll("[data-ftab]").forEach((b) => b.addEventListener("click", () => { state.funnelTab = b.dataset.ftab; renderAdminList(); }));
    if (ft === "config") bindCheckout(g.funnelHandle);
    else if (ft === "tracking") bindTracking(g.funnelHandle);
    else if (ft === "pages") bindPages(g.funnelHandle);
    else bindSaves(list);
    return;
  }

  // 3) Grilla de funnels (tarjetas cuadradas con la portada del principal)
  list.innerHTML = `<div class="apr-grid">${adminData.groups.map(funnelCardHtml).join("")}</div>`;
  list.querySelectorAll("[data-funnel]").forEach((card) => card.addEventListener("click", () => { state.adminFunnel = card.dataset.funnel; state.funnelTab = "config"; renderAdminList(); }));
}

/* ---- Modo de checkout por funnel (página de carrito vs popup) ---- */
function checkoutCardHtml(g) {
  const mode = (trackingData[g.funnelHandle] && trackingData[g.funnelHandle].checkoutMode) || "page";
  return `<div class="apr-track">
    <h3 class="apr-track-title">🧩 Tipo de funnel</h3>
    <p class="apr-help" style="margin:0 0 10px">Define cómo funciona este funnel y cuál es su página de inicio.</p>
    <div class="apr-track-row">
      <div>
        <label class="apr-label">Tipo</label>
        <select class="apr-input" id="ckt-mode">
          <option value="popup" ${mode === "popup" ? "selected" : ""}>Funnel tipo Single — 1 producto + popup de oferta → al pago</option>
          <option value="page" ${mode === "page" ? "selected" : ""}>Funnel tipo Tienda — catálogo de varios productos → carrito</option>
        </select>
      </div>
    </div>
    <div style="margin-top:14px;display:flex;align-items:center;gap:12px">
      <button class="apr-btn apr-btn-primary apr-btn-inline" id="ckt-save">Guardar tipo</button>
      <span class="apr-help apr-hidden" id="ckt-msg"></span>
    </div>
  </div>`;
}

function bindCheckout(funnelHandle) {
  const save = document.getElementById("ckt-save");
  if (save) save.onclick = () => onSaveCheckout(funnelHandle);
}

async function onSaveCheckout(funnelHandle) {
  const mode = document.getElementById("ckt-mode")?.value === "popup" ? "popup" : "page";
  const btn = document.getElementById("ckt-save");
  const msg = document.getElementById("ckt-msg");
  msg.classList.add("apr-hidden");
  btn.disabled = true; btn.innerHTML = '<span class="apr-spin"></span>';
  try {
    const { data } = await supabase.functions.invoke("admin-tracking", { body: { funnelHandle, checkoutMode: mode } });
    if (data && data.ok) {
      trackingData[funnelHandle] = Object.assign({}, trackingData[funnelHandle], { checkoutMode: mode });
      btn.textContent = "Guardado ✓";
      msg.textContent = "Tipo guardado."; msg.classList.remove("apr-hidden");
      // Re-render para que los enlaces de "Páginas del funnel" reflejen el nuevo tipo.
      setTimeout(() => { if (state.adminFunnel === funnelHandle) { renderAdminList(); } else { btn.textContent = "Guardar tipo"; btn.disabled = false; } }, 1300);
    } else {
      msg.textContent = "No se pudo guardar. " + ((data && data.error) || ""); msg.classList.remove("apr-hidden");
      btn.textContent = "Guardar tipo"; btn.disabled = false;
    }
  } catch (e) {
    msg.textContent = "No se pudo guardar."; msg.classList.remove("apr-hidden");
    btn.textContent = "Guardar tipo"; btn.disabled = false;
  }
}

/* ---- Tracking por funnel (Pixel + CAPI + eventos + páginas) ---- */
const TRACK_EVENTS = ["PageView", "ViewContent", "AddToCart", "InitiateCheckout", "Purchase"];

function xpageRowHtml(pg) {
  return `<div class="apr-xpage"><input class="apr-input" data-xurl placeholder="https://… URL de la página" value="${esc(pg?.url || "")}" /><input class="apr-input" data-xlabel placeholder="Nombre (opcional)" value="${esc(pg?.label || "")}" /><button class="apr-link apr-xremove" type="button" style="width:auto;margin:0">Quitar</button></div>`;
}

function pixelRowHtml(p, tokenPh) {
  const pid = (p && (p.pixel_id || p.pixelId)) || "";
  const configured = Boolean(p && p.capiConfigured);
  const ph = configured ? "•••••• token guardado" : (tokenPh || "Token (opcional)");
  return `<div class="apr-pixrow"><input class="apr-input" data-pixid placeholder="Pixel ID (ej. 123456789012345)" value="${esc(pid)}" /><input class="apr-input" data-pixtoken type="password" autocomplete="off" placeholder="${ph}" /><button class="apr-link apr-xremove" type="button" style="width:auto;margin:0">Quitar</button></div>`;
}

function trackingCardHtml(g) {
  const cfg = trackingData[g.funnelHandle] || { pixels: [], tiktokPixels: [], events: [], tiktokEvents: [], extraPages: [], capiConfigured: false };
  const evtChecks = (attr, selected) => TRACK_EVENTS.map((ev) =>
    `<label class="apr-evt"><input type="checkbox" ${attr}="${ev}" ${(selected || []).includes(ev) ? "checked" : ""} /> ${ev}</label>`
  ).join("");
  const metaChecks = evtChecks("data-mevt", cfg.events);
  const ttChecks = evtChecks("data-tevt", cfg.tiktokEvents);
  const pixelList = (cfg.pixels && cfg.pixels.length ? cfg.pixels : [null]).map((p) => pixelRowHtml(p, "Token CAPI (opcional)")).join("");
  const ttPixelList = (cfg.tiktokPixels && cfg.tiktokPixels.length ? cfg.tiktokPixels : [null]).map((p) => pixelRowHtml(p, "Access Token (opcional)")).join("");
  return `<div class="apr-track">
    <h3 class="apr-track-title">Pixel & seguimiento</h3>
    <p class="apr-help" style="margin:0 0 4px">Se aplica solo a este funnel. Los tokens se guardan seguros (no se muestran).</p>
    <div class="apr-platform">
      <p class="apr-platform-h">📘 Meta · Facebook e Instagram</p>
      <label class="apr-label">Pixeles — Pixel ID + Token CAPI</label>
      <p class="apr-help" style="margin:2px 0 6px">Puedes agregar varios (ej. distintas cuentas publicitarias). Deja el token vacío para conservar el guardado.</p>
      <div id="trk-pixels">${pixelList}</div>
      <button class="apr-link" id="trk-addpixel" type="button" style="width:auto;margin:8px 0 0">+ Agregar pixel</button>
      <label class="apr-label" style="margin-top:16px">Eventos de Meta</label>
      <div class="apr-evts">${metaChecks}</div>
    </div>
    <div class="apr-platform">
      <p class="apr-platform-h">🎵 TikTok</p>
      <label class="apr-label">Pixeles — Pixel ID + Access Token</label>
      <p class="apr-help" style="margin:2px 0 6px">Opcional. Igual que Meta: puedes agregar varios. Deja el token vacío para conservar el guardado.</p>
      <div id="trk-ttpixels">${ttPixelList}</div>
      <button class="apr-link" id="trk-addttpixel" type="button" style="width:auto;margin:8px 0 0">+ Agregar pixel</button>
      <label class="apr-label" style="margin-top:16px">Eventos de TikTok</label>
      <div class="apr-evts">${ttChecks}</div>
    </div>
    <div style="margin-top:16px;display:flex;align-items:center;gap:12px">
      <button class="apr-btn apr-btn-primary apr-btn-inline" id="trk-save">Guardar configuración</button>
      <span class="apr-help apr-hidden" id="trk-msg"></span>
    </div>
  </div>`;
}

function pagesCardHtml(g) {
  const cfg = trackingData[g.funnelHandle] || { extraPages: [], checkoutMode: "page", homePageHandle: "" };
  const mode = cfg.checkoutMode || "page";
  const base = (g.products.find((x) => x.storeUrl)?.storeUrl || "").replace(/\/products\/.*$/, "");
  const homeHandle = cfg.homePageHandle || "";
  const liPage = (emoji, label, href, slug) =>
    `<li><strong>${emoji} ${esc(label)}</strong> — <a class="apr-slug" href="${esc(href)}" target="_blank" rel="noopener">${esc(slug)} ↗</a></li>`;
  const liProd = (p, viewTienda) => {
    const url = p.storeUrl ? (viewTienda ? p.storeUrl + "?view=tienda" : p.storeUrl) : "";
    const link = url
      ? `<a class="apr-slug" href="${esc(url)}" target="_blank" rel="noopener">/${esc(p.handle)} ↗</a>`
      : `<span class="apr-slug">/${esc(p.handle)}</span>`;
    return `<li><strong>${esc(p.title)}</strong> — ${link}</li>`;
  };
  const fgroup = (cls, title, items) =>
    items.length ? `<div class="apr-fgroup ${cls}"><p class="apr-fgroup-h">${title}</p><ul class="apr-pglist">${items.join("")}</ul></div>` : "";

  const pageLines = [], prodLines = [], bumpLines = [];
  g.products.forEach((p) => {
    if (p.role === "bump") {
      bumpLines.push(`<li><strong>${esc(p.title)}</strong> — ${p.storeUrl ? `<a class="apr-slug" href="${esc(p.storeUrl)}" target="_blank" rel="noopener">/${esc(p.handle)} ↗</a>` : `<span class="apr-slug">/${esc(p.handle)}</span>`}</li>`);
    } else if (p.role === "principal") {
      if (mode === "page") prodLines.push(liProd(p, true)); // Tienda: el principal es un producto más
    } else {
      prodLines.push(liProd(p, mode === "page"));
    }
  });
  if (mode === "page") {
    if (homeHandle) pageLines.push(liPage("🏠", "Inicio", base + "/pages/" + homeHandle, "/pages/" + homeHandle));
    pageLines.push(liPage("🛒", "Catálogo", base + "/collections/" + g.funnelHandle, "/collections/" + g.funnelHandle));
  } else {
    const prin = g.products.find((p) => p.role === "principal");
    if (prin) {
      const link = prin.storeUrl
        ? `<a class="apr-slug" href="${esc(prin.storeUrl)}" target="_blank" rel="noopener">/${esc(prin.handle)} ↗</a>`
        : `<span class="apr-slug">/${esc(prin.handle)}</span>`;
      pageLines.push(`<li><strong>🏠 Inicio (landing)</strong> — ${link}</li>`);
    }
  }
  const bumpHeader = mode === "page" ? "🎁 Order bumps (se ofrecen en el carrito)" : "🎁 Order bumps (se ofrecen en el popup)";
  const autoPages =
    fgroup("apr-fg-pages", "📄 Páginas", pageLines) +
    fgroup("apr-fg-prod", "🛍️ Productos de tienda", prodLines) +
    fgroup("apr-fg-bumps", bumpHeader, bumpLines);
  const extra = (cfg.extraPages || []).map(xpageRowHtml).join("");
  return `<div class="apr-track">
    <h3 class="apr-track-title">Páginas del funnel</h3>
    <p class="apr-help" style="margin:0 0 4px">A qué páginas y productos pertenece este funnel (para el seguimiento). Las automáticas se detectan solas.</p>
    <div class="apr-track-block">
      <label class="apr-label">Páginas del funnel (automáticas)</label>
      ${autoPages}
    </div>
    <div class="apr-track-block">
      <label class="apr-label">Páginas extra (opcional)</label>
      <p class="apr-help" style="margin:2px 0 6px">Agrega páginas sueltas del funnel que el sistema no detecta solo (ej. una landing de promo).</p>
      <div id="trk-xpages">${extra}</div>
      <button class="apr-link" id="trk-addpage" type="button" style="width:auto;margin:8px 0 0">+ Agregar página</button>
    </div>
    <div style="margin-top:16px;display:flex;align-items:center;gap:12px">
      <button class="apr-btn apr-btn-primary apr-btn-inline" id="pages-save">Guardar páginas</button>
      <span class="apr-help apr-hidden" id="pages-msg"></span>
    </div>
  </div>`;
}

function bindTracking(funnelHandle) {
  const pcont = document.getElementById("trk-pixels");
  const ttcont = document.getElementById("trk-ttpixels");
  const bindRemoves = () => {
    if (pcont) pcont.querySelectorAll(".apr-xremove").forEach((b) => { b.onclick = () => b.closest(".apr-pixrow").remove(); });
    if (ttcont) ttcont.querySelectorAll(".apr-xremove").forEach((b) => { b.onclick = () => b.closest(".apr-pixrow").remove(); });
  };
  bindRemoves();
  const addPixel = document.getElementById("trk-addpixel");
  if (addPixel) addPixel.onclick = () => { pcont.insertAdjacentHTML("beforeend", pixelRowHtml(null, "Token CAPI (opcional)")); bindRemoves(); };
  const addTtPixel = document.getElementById("trk-addttpixel");
  if (addTtPixel) addTtPixel.onclick = () => { ttcont.insertAdjacentHTML("beforeend", pixelRowHtml(null, "Access Token (opcional)")); bindRemoves(); };
  const save = document.getElementById("trk-save");
  if (save) save.onclick = () => onSaveTracking(funnelHandle);
}

function bindPages(funnelHandle) {
  const xcont = document.getElementById("trk-xpages");
  const bindRemoves = () => { if (xcont) xcont.querySelectorAll(".apr-xremove").forEach((b) => { b.onclick = () => b.closest(".apr-xpage").remove(); }); };
  bindRemoves();
  const addPage = document.getElementById("trk-addpage");
  if (addPage) addPage.onclick = () => { xcont.insertAdjacentHTML("beforeend", xpageRowHtml(null)); bindRemoves(); };
  const save = document.getElementById("pages-save");
  if (save) save.onclick = () => onSavePages(funnelHandle);
}

async function onSavePages(funnelHandle) {
  const extraPages = Array.from(document.querySelectorAll(".apr-xpage")).map((row) => ({
    url: (row.querySelector("[data-xurl]")?.value || "").trim(),
    label: (row.querySelector("[data-xlabel]")?.value || "").trim(),
  })).filter((p) => p.url);
  const btn = document.getElementById("pages-save");
  const msg = document.getElementById("pages-msg");
  msg.classList.add("apr-hidden");
  btn.disabled = true; btn.innerHTML = '<span class="apr-spin"></span>';
  try {
    const { data } = await supabase.functions.invoke("admin-tracking", { body: { funnelHandle, extraPages } });
    if (data && data.ok) {
      trackingData[funnelHandle] = Object.assign({}, trackingData[funnelHandle], { extraPages });
      btn.textContent = "Guardado ✓";
      msg.textContent = "Páginas guardadas."; msg.classList.remove("apr-hidden");
      setTimeout(() => { btn.textContent = "Guardar páginas"; btn.disabled = false; }, 1500);
    } else {
      msg.textContent = "No se pudo guardar. " + ((data && data.error) || ""); msg.classList.remove("apr-hidden");
      btn.textContent = "Guardar páginas"; btn.disabled = false;
    }
  } catch (e) {
    msg.textContent = "No se pudo guardar."; msg.classList.remove("apr-hidden");
    btn.textContent = "Guardar páginas"; btn.disabled = false;
  }
}

async function onSaveTracking(funnelHandle) {
  const prevPixels = (trackingData[funnelHandle] && trackingData[funnelHandle].pixels) || [];
  const prevTt = (trackingData[funnelHandle] && trackingData[funnelHandle].tiktokPixels) || [];
  const collectPixels = (sel) => Array.from(document.querySelectorAll(sel + " .apr-pixrow")).map((row) => ({
    pixel_id: (row.querySelector("[data-pixid]")?.value || "").trim(),
    capi_token: (row.querySelector("[data-pixtoken]")?.value || "").trim(),
  })).filter((p) => p.pixel_id);
  const rows = collectPixels("#trk-pixels");
  const ttRows = collectPixels("#trk-ttpixels");
  const events = Array.from(document.querySelectorAll("[data-mevt]")).filter((c) => c.checked).map((c) => c.dataset.mevt);
  const tiktokEvents = Array.from(document.querySelectorAll("[data-tevt]")).filter((c) => c.checked).map((c) => c.dataset.tevt);
  const body = { funnelHandle, pixels: rows, tiktokPixels: ttRows, events, tiktokEvents };

  const btn = document.getElementById("trk-save");
  const msg = document.getElementById("trk-msg");
  msg.classList.add("apr-hidden");
  btn.disabled = true; btn.innerHTML = '<span class="apr-spin"></span>';
  try {
    const { data } = await supabase.functions.invoke("admin-tracking", { body });
    if (data && data.ok) {
      // capiConfigured local: token nuevo escrito, o ya estaba guardado para ese pixel.
      const mark = (list, prev) => list.map((p) => ({
        pixel_id: p.pixel_id,
        capiConfigured: p.capi_token ? true : Boolean((prev.find((x) => x.pixel_id === p.pixel_id) || {}).capiConfigured),
      }));
      trackingData[funnelHandle] = Object.assign({}, trackingData[funnelHandle], {
        pixels: mark(rows, prevPixels),
        tiktokPixels: mark(ttRows, prevTt),
        events, tiktokEvents,
      });
      document.querySelectorAll("#trk-pixels [data-pixtoken], #trk-ttpixels [data-pixtoken]").forEach((i) => { i.value = ""; });
      btn.textContent = "Guardado ✓";
      msg.textContent = "Configuración guardada."; msg.classList.remove("apr-hidden");
      setTimeout(() => { btn.textContent = "Guardar configuración"; btn.disabled = false; }, 1600);
    } else {
      msg.textContent = "No se pudo guardar. " + ((data && data.error) || ""); msg.classList.remove("apr-hidden");
      btn.textContent = "Guardar configuración"; btn.disabled = false;
    }
  } catch (e) {
    msg.textContent = "No se pudo guardar."; msg.classList.remove("apr-hidden");
    btn.textContent = "Guardar configuración"; btn.disabled = false;
  }
}

async function onSaveProduct(btn) {
  const id = btn.dataset.save;
  const input = btn.parentElement.querySelector(`[data-url="${CSS.escape(id)}"]`);
  const msg = btn.closest(".apr-abody").querySelector("[data-amsg]");
  msg.classList.add("apr-hidden");
  const downloadUrl = input.value.trim();
  btn.disabled = true; btn.innerHTML = '<span class="apr-spin"></span>';
  try {
    const { data, error } = await supabase.functions.invoke("admin-products", {
      body: { shopifyProductId: id, title: btn.dataset.title, handle: btn.dataset.handle, downloadUrl },
    });
    if (data && data.ok) {
      if (adminData) { for (const g of adminData.groups) { const pr = g.products.find((x) => x.shopifyProductId === id); if (pr) pr.downloadUrl = downloadUrl; } }
      btn.textContent = "Guardado ✓";
      const chip = btn.closest(".apr-abody").querySelector(".apr-dlchip");
      if (chip) {
        if (downloadUrl) { chip.className = "apr-chip apr-dlchip apr-chip-ok"; chip.textContent = "Con descarga"; }
        else { chip.className = "apr-chip apr-dlchip apr-chip-warn"; chip.textContent = "Falta enlace"; }
      }
      setTimeout(() => { btn.textContent = "Guardar"; btn.disabled = false; }, 1500);
    } else {
      msg.textContent = (error || (data && data.error)) ? "Revisa que la URL empiece con http(s):// e intenta de nuevo." : "No se pudo guardar.";
      msg.classList.remove("apr-hidden"); btn.textContent = "Guardar"; btn.disabled = false;
    }
  } catch (e) {
    msg.textContent = "No se pudo guardar."; msg.classList.remove("apr-hidden"); btn.textContent = "Guardar"; btn.disabled = false;
  }
}

/* ---- Pedidos (admin): reenviar correo de acceso + búsqueda ---- */
async function renderPedidos(c) {
  const head = `<p class="apr-pagesub" style="margin:18px 0 8px">Tus ventas. Si a un cliente no le llegó el correo, reenvíale el acceso aquí.</p>`;
  if (!ordersData) {
    c.innerHTML = head + `<div class="apr-center"><span class="apr-spin"></span></div>`;
    const { data, error } = await supabase.functions.invoke("admin-orders", { method: "GET" });
    if (error || !data || !data.ok) { c.innerHTML = head + `<div class="apr-empty">No pudimos cargar los pedidos.</div>`; return; }
    if (!data.orders || !data.orders.length) { c.innerHTML = head + `<div class="apr-empty"><h2>Aún no hay pedidos</h2><p>Cuando entren ventas aparecerán aquí.</p></div>`; return; }
    ordersData = data.orders;
  }
  c.innerHTML = head + `
    <div class="apr-toolbar">
      <input class="apr-input apr-search" id="apr-ord-q" type="search" placeholder="Buscar por correo, pedido, fecha o producto…" />
    </div>
    <div id="apr-ord-list"></div>`;
  document.getElementById("apr-ord-q").addEventListener("input", renderPedidosList);
  renderPedidosList();
}

function pedidoRowHtml(o) {
  const products = (o.products || []).join(" · ");
  return `<div class="apr-order">
    <div class="apr-order-info">
      <div class="apr-order-top"><strong>${esc(o.name || "Pedido")}</strong>${o.date ? `<span class="apr-chip apr-chip-ok">${esc(o.date)}</span>` : ""}</div>
      <p class="apr-order-email">${esc(o.email || "")}</p>
      ${products ? `<p class="apr-order-prods">${esc(products)}</p>` : ""}
    </div>
    <div class="apr-order-action">
      <button class="apr-btn apr-btn-primary apr-btn-sm" data-resend="${esc(o.orderId)}">Reenviar</button>
      <span class="apr-help apr-hidden" data-rmsg="${esc(o.orderId)}"></span>
    </div>
  </div>`;
}

function renderPedidosList() {
  const list = document.getElementById("apr-ord-list");
  if (!list || !ordersData) return;
  const q = (document.getElementById("apr-ord-q")?.value || "").trim().toLowerCase();
  const orders = ordersData.filter((o) => !q
    || (o.email || "").toLowerCase().includes(q)
    || (o.name || "").toLowerCase().includes(q)
    || (o.date || "").includes(q)
    || (o.products || []).join(" ").toLowerCase().includes(q));
  if (!orders.length) { list.innerHTML = `<div class="apr-empty">No hay pedidos que coincidan.</div>`; return; }
  list.innerHTML = orders.map(pedidoRowHtml).join("");
  list.querySelectorAll("[data-resend]").forEach((btn) => btn.addEventListener("click", () => onResendOrder(btn)));
}

async function onResendOrder(btn) {
  const orderId = btn.dataset.resend;
  const msg = btn.parentElement.querySelector("[data-rmsg]");
  msg.classList.add("apr-hidden");
  const original = btn.innerHTML;
  btn.disabled = true; btn.innerHTML = '<span class="apr-spin"></span>';
  try {
    const { data, error } = await supabase.functions.invoke("admin-orders", { body: { orderId } });
    if (data && data.ok) {
      btn.textContent = "Reenviado ✓";
      msg.textContent = "Enviado a " + (data.email || ""); msg.classList.remove("apr-hidden");
      setTimeout(() => { btn.innerHTML = original; btn.disabled = false; }, 2500);
    } else {
      msg.textContent = "No se pudo reenviar. Intenta de nuevo."; msg.classList.remove("apr-hidden");
      btn.innerHTML = original; btn.disabled = false;
    }
  } catch (e) {
    msg.textContent = "No se pudo reenviar."; msg.classList.remove("apr-hidden");
    btn.innerHTML = original; btn.disabled = false;
  }
}

/* ============ INIT ============ */
(async function init() {
  if (!SUPABASE_URL || !ANON_KEY) {
    root.innerHTML = `<div class="apr-center">Falta configurar Supabase en la sección.</div>`;
    return;
  }
  root.innerHTML = `<div class="apr-center"><span class="apr-spin"></span></div>`;
  const { data: { session } } = await supabase.auth.getSession();
  if (!session) { renderLogin(); return; }
  await loadAppData();
})();
